import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Popup from "reactjs-popup";
import Login from "../../pages/Login";
import { IoChevronDown } from "react-icons/io5";
import { useSelector } from "react-redux";
import ThemeToggle from "../ThemeToggle";
import { useTheme } from "../../context/ThemeContext";

const Header = () => {
  const { logOut, user } = useContext(AuthContext);
  const { currentMenuLabel } = useSelector((state) => state.menu);
  const [openDialog, setOpenDialog] = useState(false);
  const [password, setPassword] = useState(false);
  const { isDark } = useTheme();

  const handlePassword = () => {
    setOpenDialog(false);
    setPassword(true);
  };

  const closeModal = () => {
    setPassword(false);
  };

  const toggleDialog = () => {
    setOpenDialog((prev) => !prev);
  };

  // Theme colors
  const bgColor = isDark ? '#1e293b' : '#ffffff';
  const borderColor = isDark ? '#334155' : '#e2e8f0';
  const textColor = isDark ? '#f1f5f9' : '#1e293b';
  const mutedColor = isDark ? '#94a3b8' : '#64748b';
  const hoverBgColor = isDark ? '#334155' : '#f1f5f9';

  return (
    <header 
      className="h-14 flex items-center justify-between px-6"
      style={{ 
        backgroundColor: bgColor, 
        borderBottom: `1px solid ${borderColor}` 
      }}
    >
      {/* Left side - Current page title */}
      <div className="flex items-center">
        <h1 className="text-lg font-semibold" style={{ color: textColor }}>
          {currentMenuLabel || "Medical AI Suite"}
        </h1>
      </div>

      {/* Right side - User menu */}
      <div className="flex items-center gap-2">
        {/* Theme Toggle */}
        <ThemeToggle />
        
        {/* User dropdown */}
        <div className="relative">
          <button
            onClick={toggleDialog}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors"
            style={{ backgroundColor: openDialog ? hoverBgColor : 'transparent' }}
          >
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold"
              style={{ backgroundColor: isDark ? '#3b82f6' : '#0f172a', color: '#ffffff' }}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div className="hidden sm:block text-left">
              <p className="text-sm font-medium" style={{ color: textColor }}>
                {user?.name?.split(" ")[0]}
              </p>
            </div>
            <IoChevronDown className="w-4 h-4" style={{ color: mutedColor }} />
          </button>

          {/* Dropdown menu */}
          {openDialog && (
            <>
              <div
                onClick={toggleDialog}
                className="fixed inset-0 z-40"
              />
              <div 
                className="absolute right-0 top-full mt-1 w-48 rounded-lg shadow-lg py-1 z-50 animate-fade-in"
                style={{ backgroundColor: bgColor, border: `1px solid ${borderColor}` }}
              >
                <div className="px-4 py-2" style={{ borderBottom: `1px solid ${borderColor}` }}>
                  <p className="text-sm font-medium" style={{ color: textColor }}>{user?.name}</p>
                  <p className="text-xs" style={{ color: mutedColor }}>{user?.email}</p>
                </div>
                <button
                  onClick={handlePassword}
                  className="w-full text-left px-4 py-2 text-sm transition-colors"
                  style={{ color: textColor }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = hoverBgColor}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Update Password
                </button>
                <button
                  onClick={logOut}
                  className="w-full text-left px-4 py-2 text-sm transition-colors"
                  style={{ color: textColor }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = hoverBgColor}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Password change modal */}
      <Popup
        onClose={closeModal}
        modal
        open={password}
        position="center center"
      >
        <Login passwordChange={true} />
      </Popup>
    </header>
  );
};

export default Header;
